module.exports = __webpack_public_path__ + "img/IT0000049355813.76d7e5f3.png";